var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { background: "#091e57 url(./static/img/body-bg.png)" } },
    [
      _c("div", [
        _c("div", { staticClass: "bhxc-header" }, [
          _c(
            "div",
            [
              _c(
                "el-row",
                { attrs: { gutter: 100 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("img", {
                      staticStyle: {
                        float: "left",
                        position: "absolute",
                        left: "6vh",
                        top: "2vh"
                      },
                      attrs: { src: "static/img/litleLogo.png" }
                    }),
                    _c("div", { staticClass: "Project_overview" })
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "User-login1" }, [
                      _c(
                        "span",
                        {
                          staticClass: "Backstage",
                          staticStyle: {
                            "line-height": "3.5vh",
                            height: "3.5vh",
                            display: "flex"
                          }
                        },
                        [
                          _c("img", {
                            staticStyle: {
                              height: "3.5vh",
                              "margin-right": "1vh"
                            },
                            attrs: { src: "static/img/dianxinLogo.png" }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "0.8vw",
                                padding: "0.5vh 0.6vw"
                              }
                            },
                            [_vm._v("欢迎您! 管理员")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "out",
                              staticStyle: {
                                cursor: "pointer",
                                "margin-right": "1vh"
                              },
                              on: { click: _vm.manage }
                            },
                            [
                              _c("svg-icon", {
                                staticStyle: {
                                  width: "25px",
                                  height: "25px",
                                  "margin-top": "5px"
                                },
                                attrs: { "icon-class": "index" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                "margin-right": "1vh"
                              },
                              on: { click: _vm.logout }
                            },
                            [
                              _c("svg-icon", {
                                staticClass: "user-avatar",
                                staticStyle: {
                                  width: "25px",
                                  height: "25px",
                                  "margin-top": "5px"
                                },
                                attrs: { "icon-class": "tuichu" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "Full-screen1" },
                            [
                              _c("screenfull", {
                                staticClass: "screenfull right-menu-item",
                                staticStyle: { "margin-top": "5px" }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }